import moment from 'moment';
import isTextColumn from './isTextColumn';

const formatColumnValue = (keyName, record) => {
  const value = record[keyName];

  if (keyName === 'month') {
    return moment(value).format('YYYY-MM');
  } if (keyName === 'day') {
    return moment(value).format('YYYY-MM-DD');
  } else if (typeof value === 'number' || !isTextColumn(keyName)) {
    return Number(value).toLocaleString() || 0;
  }
  return value || 0;
};

export default formatColumnValue;
